import {
    LOGIN_REQUEST_ERROR,
    LOGIN_REQUEST_SENT,
    LOGIN_REQUEST_SUCCESS,
    LOGOUT,
    REMOVE_PROFILE_IMAGE,
    TOKEN_REFRESH_REQUEST_ERROR,
    TOKEN_REFRESH_REQUEST_SENT,
    TOKEN_REFRESH_REQUEST_SUCCESS
} from "./actions";
import {authService} from '../service/auth_service'
import {getNomencalture} from "./symptoms_actions";
import history from '../helpers/history'
import {Routes} from '../constants/routes';
import {getUserInfo} from "./users_actions";
import {getChildren} from "./children_actions";

/**
 * Login action, dispatch login, store user date in localstorage
 *
 * @param {string} email - E-mail used for login
 * @param {string} password - Password used for login
 * @param {boolean} linkLogin - flag that if set means that the login is from a temporary account link
 * @returns {function} dispatch function
 */
export function login(email, password, linkLogin) {

    return (dispatch) => {
        dispatch({type: LOGIN_REQUEST_SENT});
        authService.login(email, password)
            .then(res => {
                if (res.access_token && res.refresh_token) {
                    dispatch({type: LOGIN_REQUEST_SUCCESS, response: res});
                    authService.createDeviceInfo();
                    dispatch(getUserInfo(true));
                    dispatch(getNomencalture());
                    dispatch(getChildren());
                }
            })
            .catch((error) => {
                if (!linkLogin) {
                    dispatch({type: LOGIN_REQUEST_ERROR, response: error});
                }
            });
    }
}

/**
 * Login with google action, dispatch login, store user date in localstorage
 *
 * @param {string} id_token
 * @param {boolean} linkLogin - flag that if set means that the login is from a temporary account link
 * @returns {object} promise object
 */
export function loginWithGoogle(id_token, linkLogin) {
    return (dispatch) => {
        dispatch({type: LOGIN_REQUEST_SENT});
        authService.loginWithGoogle(id_token)
            .then(res => {
                if (res.access_token && res.refresh_token) {
                    dispatch({type: LOGIN_REQUEST_SUCCESS, response: res});
                    authService.createDeviceInfo();
                    dispatch(getUserInfo(true));
                    dispatch(getNomencalture());
                    dispatch(getChildren());
                }
            })
            .catch((error) => {
                if (!linkLogin) {
                    dispatch({type: LOGIN_REQUEST_ERROR, response: error});
                }
            });
    }
}

/**
 * Login with google action, dispatch login, store user date in localstorage
 *
 * @param {string} id_token
 * @param {string} client_id - flag that if set means that the login is from a temporary account link
 * @param {string} user - optional user object which Apple sends to us the first time
 * @returns {object} promise object
 */
export function loginWithApple(id_token, client_id, user) {
    return (dispatch) => {
        dispatch({type: LOGIN_REQUEST_SENT});
        authService.loginWithApple(id_token, client_id, user)
            .then(res => {
                if (res.access_token && res.refresh_token) {
                    dispatch({type: LOGIN_REQUEST_SUCCESS, response: res});
                    authService.createDeviceInfo();
                    dispatch(getUserInfo(true));
                    dispatch(getNomencalture());
                    dispatch(getChildren());
                }
            })
            .catch((error) => {
                    dispatch({type: LOGIN_REQUEST_ERROR, response: error});
            });
    }
}

/**
 * Login with facebook action, dispatch login, store user date in localstorage
 *
 * @param {string} acessToken - access token from facebook
 * @param {boolean} linkLogin - flag that if set means that the login is from a temporary account link
 * @returns {object} promise object
 */
export function loginWithFacebook(accessToken, linkLogin) {
    return (dispatch) => {
        dispatch({type: LOGIN_REQUEST_SENT});
        authService.loginWithFacebook(accessToken)
            .then(res => {
                if (res.access_token && res.refresh_token) {
                    dispatch({type: LOGIN_REQUEST_SUCCESS, response: res});
                    authService.createDeviceInfo();
                    dispatch(getUserInfo(true));
                    dispatch(getNomencalture());
                    dispatch(getChildren());
                }
            })
            .catch((error) => {
                if (!linkLogin) {
                    dispatch({type: LOGIN_REQUEST_ERROR, response: error});
                }
            });
    }
}

/**
 * Refresh token action, dispatch action.
 *
 * @param {string} token - the refresh token
 * @returns {function} dispatch function
 */
export function refreshToken(token) {
    return (dispatch) => {
        dispatch({type: TOKEN_REFRESH_REQUEST_SENT});
        authService.refreshToken(token)
            .then(res => {
                if (res.access_token && res.refresh_token) {
                    dispatch({type: TOKEN_REFRESH_REQUEST_SUCCESS, response: res});
                }
            })
            .catch((error) => {
                dispatch({type: LOGOUT});
                dispatch({type: TOKEN_REFRESH_REQUEST_ERROR, response: error});
                history.push(Routes.LOGIN);
            });
    }
}

/**
 * Logout action, clear user data and tokens from storage.
 */
export function logout(username, password) {
    return (dispatch) => {
        try {
            if (window.twilioRoom) {
                window.twilioRoom.disconnect();
            }
        } catch (e) {

        }
        try {
            authService.logout();
        } catch (e) {
            console.log(e)
            dispatch({type: LOGOUT});
            history.push(Routes.LOGIN);
        }
        dispatch({type: LOGOUT});
        dispatch({type: REMOVE_PROFILE_IMAGE})
        if (username && password) {
            history.push(Routes.LOGIN + `?username=${username}&password=${password}`);
        } else {
            history.push(Routes.LOGIN);
        }
    }
}
